import { useMutation, useQueryClient } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useCreateBanner = () => {
  const queryClient = useQueryClient();
   const prefix = process.env.REACT_APP_PROXY_PREFIX || '';
  return useMutation({
    mutationFn: async (input) => {
      const result = await restClient({
        url: `${prefix}/banner`,
        method: 'POST',
        data: input
      });
      return result;
    },
    onSuccess: () => {
      // Invalidate and refetch banners list after successful creation
      queryClient.invalidateQueries(['banners']);
    }
  });
};
